/**
 * @desc 修改周分计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanWeekCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/week/updatePartPlan',
    data,
  });
}

export function mock(
  data: defs.PlanWeekCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/week/updatePartPlan',
    data,
  });
}
